import React, { Component } from 'react'
import "./main.scss"
import Banner from './banner/Banner'
export default class App extends Component {
  render() {
    return (
      <div> 
        <Banner></Banner>
      </div>
      
    )
  }
}
